import React from 'react';
import { addContentPath } from '../../util/pathUtil';
import Header from './Common/header';

export default class Content_picture extends React.Component {
    render() {
        const { data = {}, eid } = this.props;
        const { moreLocal, iconMore } = data;
        return (
            <div className="item" id={`item_${eid}`}>
                <Header ecId={`${this && this.props && this.props.ecId || ''}_Header@0qp80k`} data={data} eid={eid} />
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view" id="content_view_id_57335" style={{ overflow: 'hidden' }}>
                        <div className="ant-spin-nested-loading">
                            <div className="ant-spin-container">
                                <table id="slideArea_57335" border="0" style={{ width: '100%', height: '165px', tableLayout: 'fixed', borderSpacing: '0px' }}>
                                    <tbody>
                                    <tr>
                                        <td width="*">
                                            <div className="slideContinar slideritem">
                                                <div className="slideDiv">
                                                    <img src={addContentPath('/page/resource/userfile/image/elementPrew/slide/slidePic.png')} alt="" style={{ width: '100%', height: '160px' }} />
                                                </div>
                                            </div>
                                        </td>
                                        <td style={{ width: '150px' }}>
                                            <div className="slideTitle" style={{ zIndex: '1001', position: 'relative', width: '150px', float: 'right' }}>
                                                <div className="slideTitleFloat" style={{ display: 'block', top: '0', right: '0px', background: `url(${addContentPath('/page/resource/userfile/image/elementPrew/slide/navFront1.png')}) 0% 0% / 100% 100% no-repeat`, position: 'absolute', height: '40px', width: '165px' }} />
                                                <div className="slideTitleNavContainer">
                                                    <div className="slidnavtitle"
                                                      style={{ background: `url(${addContentPath('/page/resource/userfile/image/elementPrew/slide/navbg1.png')}) 0% 0% / 100% 100% no-repeat`, cursor: 'pointer', height: '40px' }}
                                                    >&nbsp;</div>
                                                    <div className="slidnavtitle"
                                                      style={{ background: `url(${addContentPath('/page/resource/userfile/image/elementPrew/slide/navbg2.png')}) 0% 0% / 100% 100% no-repeat`, cursor: 'pointer', height: '40px' }}
                                                    >&nbsp;</div>
                                                    <div className="slidnavtitle activeSlide"
                                                      style={{ background: `url(${addContentPath('/page/resource/userfile/image/elementPrew/slide/navbg3.png')}) 0% 0% / 100% 100% no-repeat`, cursor: 'pointer', height: '40px' }}
                                                    >&nbsp;</div>
                                                    <div className="slidnavtitle"
                                                      style={{ background: `url(${addContentPath('/page/resource/userfile/image/elementPrew/slide/navbg4.png')}) 0% 0% / 100% 100% no-repeat`, cursor: 'pointer', height: '40px' }}
                                                    >&nbsp;</div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer" id={`footer_${eid}`} style={{ textAlign: 'right' }}>
                    {moreLocal == 'footer' ? <a href="javascript:;"><img src={addContentPath(iconMore)} alt="" /></a> : ''}
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_slide.js